import { FileUp, Lock } from 'lucide-react'
import { Badge, StatusPill } from '@insightai/ui'
import { credibilityBand } from './types'

/**
 * F0-30 — SRE-FR-003 credibility bands.
 *
 * Rendered through `<StatusPill>`, which guarantees the icon-plus-text pairing;
 * a bare colour dot on a claim card would be a colour-only encoding of the single
 * most decision-relevant attribute on the knowledge feed.
 */
export function CredibilityBadge({ score, showScore = true }: { score: number; showScore?: boolean }) {
  const band = credibilityBand(score)
  return (
    <StatusPill
      tone={band.tone}
      size="sm"
      label={showScore ? `${band.label} · ${score.toFixed(2)}` : band.label}
    />
  )
}

/** F0-32 — SRE-FR-010. Distinguishes what the client gave us from what we found. */
export function ClientProvidedBadge() {
  return (
    <Badge tone="info" icon={<FileUp aria-hidden className="size-3" />}>
      Client-provided
    </Badge>
  )
}

/**
 * F0-32 — SRE-FR-015. Paid-database provenance, which constrains what may be
 * redistributed in an export, so it must be visible before someone builds a
 * client deck on it.
 */
export function LicensedDataBadge({ note }: { note?: string }) {
  return (
    <Badge tone="warning" icon={<Lock aria-hidden className="size-3" />} title={note}>
      Licensed source
    </Badge>
  )
}
